import axiosInstance from "../../../util/axiosInstance";

export const fetchinvitationtemplates = async (
  eventCategoryName,
  eventName,
  screenType,
) => {
  try {
    const response = await axiosInstance.get(
      `/templates-bg/list?platform=${screenType}`,
    );

    const allData = response.data.data;
    // Normalize keys to lowercase
    const normCategory = eventCategoryName.toLowerCase().replace(/\s+/g, "");
    const normEvent = eventName.toLowerCase().replace(/\s+/g, "");

    // Get default data (the entire default.default object)
    const defaultData = allData.default?.default;
    console.log("Normalised Event Name ", normCategory, "***", normEvent);
    // 1. Check if category exists
    if (!allData[normCategory]) {
      console.warn("No data found for category:", normCategory);
      console.log("Returning default data");
      return defaultData || null;
    }

    const categoryData = allData[normCategory];

    // 2. Try to match event name exactly
    const subcategoryKeys = Object.keys(categoryData);
    console.log("Available events in category:", subcategoryKeys);

    const matchingKey = subcategoryKeys.find(
      (key) => key.toLowerCase().trim() === normEvent,
    );

    console.log("Found matching key:", matchingKey);

    if (matchingKey) {
      // 3. Found exact match - return it
      const subcategoryData = categoryData[matchingKey];
      console.log("Exact match data:", subcategoryData);

      if (subcategoryData && subcategoryData.images) {
        return subcategoryData;
      }
    }

    // 4. No exact match found - return default
    console.warn("No exact event match found, returning default");
    return defaultData || null;
  } catch (error) {
    console.log("Error found while fetching templates:", error);
    return null;
  }
};

export const fetchInvitationTemplateWithPng = async (
  eventCategoryName,
  eventName,
  screenType,
  png,
) => {
  console.log(
    "fetchInvitationTemplateWithPng",
    eventCategoryName,
    eventName,
    screenType,
    png,
  );
  const baseData = await fetchinvitationtemplates(
    eventCategoryName,
    eventName,
    screenType,
  );
  console.log("Image list", baseData);
  if (!baseData) return null;

  if (png) {
    const matched = baseData.images.find((img) => img.name === png);
    if (matched) {
      console.log("Matched image found:", matched);
      return {
        ...baseData,
        images: [matched], // return only the matched image
      };
    }
  }

  return baseData;
};

export const getinvitation_templates_by_category = async (url) => {
  console.log("url123", url);

  try {
    const response = await axiosInstance.get(url, { responseType: "blob" });
    let data = response?.data;
    console.log("got api response", response);
    if (!data) return null;

    // Ensure we have a real Blob
    if (!(data instanceof Blob)) {
      // Some dev servers wrap Blob in { data: Blob }, extract it
      if (data.data && data.data instanceof Blob) {
        data = data.data;
      } else {
        console.warn("Not a real Blob", data);
        return null;
      }
    }

    // Check if the Blob is an image
    if (!data.type.startsWith("image/")) {
      const text = await data.text().catch(() => "");
      console.warn("Blob is not an image, server said:", text || data.type);
      return null;
    }
    console.log("Image template", data);
    console.log("got valid image blob here", data);
    return data;
  } catch (error) {
    console.error("Failed to load image", error);
    return null;
  }
};
